import {DatePipe, NgForOf, NgIf} from '@angular/common';
import {AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterLink} from '@angular/router';
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {DialogService} from "../../../_modal/dialog.service";
import { AbstractControl,FormBuilder,FormGroup,ReactiveFormsModule, ValidationErrors,Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {PocService} from "../../../../services/poc-service/poc.service";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {ShortClientDto} from "../../../_models/client.dtos";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {CookieService} from "ngx-cookie-service";
import { LaboService } from '../../../../services/labo-service/labo.service';
import { ProduitStockDTO } from '../../../_models/ProduitStockDTO';
import { ProduitStocktService } from '../../../../services/produit-service/produit.service';
import { EmplacementService } from '../../../../services/emplacement-service/emplacement.service';
import { FournisseurService } from '../../../../services/fournisseur-service/fournisseur.service';
import { FournisseurDTO } from '../../../_models/FournisseurDTO';
import { emplacementDTO } from '../../../_models/emplacementDto';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../../../environments/environment';
@Component({
    standalone: true,
    providers: [HandleErrorsService, ApiService, Endpoints, DialogService, PocService, ClientsService,],
    imports: [MatListModule,
        MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
        MatDatepickerInput,MatDatepickerModule,
    MatNativeDateModule, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, DatePipe, MatCheckbox
    ],

  selector: 'app-stock-produit',
  templateUrl: './stock-produit.component.html',
  styleUrl: './stock-produit.component.scss'
})
export class StockProduitComponent {
    @Input() clientsPoc: any[] = [];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    editForm: FormGroup;
    form: FormGroup;
    clientList: ShortClientDto[]
    dataSource = new MatTableDataSource<ProduitStockDTO>();
    searchValue: string = ''
    prd?: ProduitStockDTO
    loadingTable: boolean = true;
    fournisseurs: FournisseurDTO[] = [];
   localisations: emplacementDTO[] = [];


displayedColumns: string[] = [
  'nom',
  'typeProduit',
  'unite',
  'quantite',
  'conditionStockage',
  'temperatureStockage',
  'numeroLot',
  'documentPath',
  'fournisseurId',
  'emplacementId',
  'stabiliteApresOuverture',
  'seuilAlertePeremption',
  'dangerosite',
  'dateFabrication',
  'dateOuverture',
  'datePeremption',
  'dateCreation',
  'dateModification'
];
    columns: string[] = [...this.displayedColumns];
typeProduits: string[] = [
    'CONSOMMABLE',
    'REACTIF_CHIMIQUE',
    'STANDARD',
    'MILIEU_CULTURE',
    'PRODUIT_NETTOYAGE',
    'KIT_ANALYSE'
];

    constructor(
        private sanitizer: DomSanitizer,
        private cookieService: CookieService,
        private handleErrorsService: HandleErrorsService,
        private produitStockService: ProduitStocktService,
        private emplacementService: EmplacementService,
        private fournisseurService:FournisseurService,
        private clientService: ClientsService,
        private dialogService: DialogService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private overlayContainer: OverlayContainer) {
    }

    ngOnInit(): void {
        this.fetchProductList()
        this.initializeEditForm();
        this.fetchClientList();
        this.initializeCreateForm()
        this.getColsCookie()
        this.loadFournisseurs()
        this.loadLocalisations()
    }

fetchProductList(): void {
  this.produitStockService.getAllProducts().subscribe({
    next: (products) => {
      console.log('✅ Fournisseurs actifs reçus:', products);
      this.dataSource.data = products;
    },
    error: (err) => {
      console.error("❌ Erreur :", err);
    }
  });
}

loadFournisseurs(): void {
  this.fournisseurService.getAllFournisseurs().subscribe(data => {
    this.fournisseurs = data;
  });
}

loadLocalisations(): void {
  this.emplacementService.getAllEmplacements().subscribe(data => {
    this.localisations = data;
  });
}

    

    ngAfterViewInit() {
        this.initializePaginatorAndSort();
    }

    private initializePaginatorAndSort() {
        this.dataSource.filter = this.searchValue
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'asc';
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
    }

initializeEditForm() {
  this.editForm = this.fb.group({
  id: [null],
  nom: ['', Validators.required],
  typeProduit: ['', Validators.required],
  documentPath: this.fb.control([]),
  unite: ['', Validators.required],
  seuilAlertePeremption:['',Validators.required],
  quantite: ['', Validators.required],
  conditionStockage: ['', Validators.required],
  dangerosite: ['', Validators.required],
  dateOuverture: ['', Validators.required],
  datePeremption: ['', Validators.required],
  stabiliteApresOuverture: [null, [Validators.required, Validators.min(1)]],
  dateFabrication:['', Validators.required],
  temperatureStockage: ['', Validators.required],
  numeroLot: ['', Validators.required],
  emplacementId: [null, Validators.required],
  fournisseurId: [null, Validators.required],
  });
}
selectedFile: File | null = null;
onFileChange(event: any): void {
  const file = event.target.files[0];
  if (file) {
    this.selectedFile = file;
  }
}
isString(value: any): value is string {
  return typeof value === 'string';
}

getFileName(path: string): string {
  if (typeof path !== 'string') return '';
  const parts = path.split(/[\\/]/);
  return parts[parts.length - 1];
}



initializeCreateForm() {
  this.form = this.fb.group({
    nom: ['', Validators.required],
    typeProduit: ['', Validators.required],
    unite: ['', Validators.required],
    seuilAlertePeremption: ['', Validators.required],
    quantite: ['', Validators.required],
    documentPath: this.fb.control([]),
    conditionStockage: [''],
    temperatureStockage: [''],
    dangerosite: [''],
    stabiliteApresOuverture: [null],
    dateFabrication:['',Validators.required],
    numeroLot: [''],
    fournisseurId: [null, Validators.required],     // ici c’est un id number
    emplacementId: [null, Validators.required],
    dateOuverture: [null],     // Ajouté
    datePeremption: [null],   

  });
}
getDocumentsList(path: any): string[] {
  if (typeof path === 'string') {
    return path.split(';');
  }
  return [];
}

getDocumentUrl(filePath: string): string {
  const url = `${window.location.protocol}//${window.location.hostname}/${encodeURI(filePath)}`;
  console.log("Generated document URL:", url);
  return url;
}


  selectedPreview: string | null = null;


  togglePreview(path: string): void {
    this.selectedPreview = this.selectedPreview === path ? null : path;
  }

  isPDF(path: string): boolean {
    return path.toLowerCase().endsWith('.pdf');
  }
  closePreview(): void {
  this.selectedPreview = null;
}

getSafeUrlGoogleDocs(path: string): SafeResourceUrl {
  const fullUrl = `${environment.base_url}/${path}`;
  const googleDocsUrl = `https://docs.google.com/gview?url=${encodeURIComponent(fullUrl)}&embedded=true`;
  return this.sanitizer.bypassSecurityTrustResourceUrl(googleDocsUrl);
}


  isImage(path: string): boolean {
    return /\.(jpg|jpeg|png|gif|bmp)$/i.test(path);
  }

  isOfficeFile(path: string): boolean {
    return /\.(doc|docx|xls|xlsx|ppt|pptx)$/i.test(path);
  }

  getSafeUrl(filePath: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.base_url}/${filePath}`);
  }

  getGoogleDocsViewerUrl(filePath: string): string {
    const encodedUrl = encodeURIComponent(`${environment.base_url}/${filePath}`);
    return `https://docs.google.com/gview?url=${encodedUrl}&embedded=true`;
  }

baseUrl = `${environment.base_url}`; // adapte selon ton backend


getSafeDocumentUrl(documentPath: string): SafeResourceUrl {
  const urlPath = this.getDocumentUrl(documentPath);
  return this.sanitizer.bypassSecurityTrustResourceUrl(urlPath);
}
    getClientName(clientId: number): string {
        const client = this.clientList.find(client => client.id === clientId);
        return client?.socialReason ?? 'N/A';  // Utilisation de l'opérateur "??" pour éviter "undefined"
    }
 isDocument(path: string): boolean {
  return /\.(pdf|doc|docx|xls|xlsx|ppt|pptx)$/i.test(path);
}     
      
openEditModal(element: ProduitStockDTO) {
  console.log("🛠️ Données à éditer :", element); // vérifie que id est bien présent
  this.editForm.patchValue({
    id: element.id, // <-- très important, car il peut être ignoré dans patchValue simple
    nom: element.nom,
    documentPath: Array.isArray(element.documentPath) ? element.documentPath : [],
    typeProduit: element.typeProduit,
    unite: element.unite,
    seuilAlertePeremption: element.seuilAlertePeremption,
    quantite:element.quantite,
    conditionStockage: element.conditionStockage,
    dangerosite: element.dangerosite,
    dateOuverture: element.dateOuverture,
    datePeremption: element.datePeremption,
    dateFabrication: element.dateFabrication,
    numeroLot: element.numeroLot,
    stabiliteApresOuverture: element.stabiliteApresOuverture,
    temperatureStockage: element.temperatureStockage,
    emplacementId: element.emplacementId,
    fournisseurId: element.fournisseurId
  });

  this.modalService.open(this.editModal, {
    ariaLabelledBy: 'modal-basic-title',
    size: 'lg'
  });
}
selectedElement: any; // Remplace `any` par le bon type si tu as un modèle (ex: StockProduit)


    private fetchClientList() {
        this.clientService.loadClients().subscribe({
            next: response => {
                if(response.status){
                    this.clientList = response.data
                }
            }
        })
    }
  // variable pour stocker le fichier sélectionné

onFilesSelected(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    const newFiles = Array.from(input.files);
    const existingFileNames = new Set(this.selectedFiles.map(f => f.name + f.size));
    const uniqueNewFiles = newFiles.filter(f => !existingFileNames.has(f.name + f.size));
    this.selectedFiles = [...this.selectedFiles, ...uniqueNewFiles];
  }
}
selectedFiles: File[] = [];

handleFileChange(event: Event) {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    this.selectedFiles = Array.from(input.files);
    console.log('📂 Fichiers sélectionnés :', this.selectedFiles);
  }
}

saveProduct(): void {
  console.log("💡 Validation du formulaire", this.form.value);

  if (this.form.valid) {
    // 🔧 Cloner proprement l’objet
    const formValue = JSON.parse(JSON.stringify(this.form.value));

    // 🗓️ Corriger les dates en 'yyyy-MM-dd'
    const dateFields = ['dateFabrication', 'dateOuverture', 'datePeremption'];
    dateFields.forEach(field => {
      if (formValue[field]) {
        formValue[field] = new Date(formValue[field]).toISOString().split('T')[0];
      }
    });

    const formData = new FormData();
    formData.append('dto', new Blob([JSON.stringify(formValue)], { type: 'application/json' }));

    if (this.selectedFiles.length > 0) {
      this.selectedFiles.forEach(file => {
        formData.append('files', file);
      });
      console.log("📁 Fichiers ajoutés au FormData :", this.selectedFiles.map(f => f.name));
    } else {
      console.log("⚠️ Aucun fichier sélectionné");
    }

    this.produitStockService.createProduit(formData).subscribe({
      next: response => {
        console.log("✅ Produit créé avec succès :", response);
        this.form.reset();
        this.selectedFiles = [];
        this.fetchProductList();
        this.modalService.dismissAll();
        this.dialogService.openSuccessDialog("Produit ajouté avec succès.");
      },
      error: err => {
        console.error("❌ Erreur API :", err);
      }
    });
  } else {
    console.warn("⚠️ Formulaire invalide, erreurs suivantes :");

    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control && control.invalid) {
        console.warn(` - Champ "${field}" invalide : erreurs =`, control.errors);
      }
    });

    this.dialogService.openInvalidFormDialog();
  }
}


seuils = [
  { label: '15 jours', value: 15 },
  { label: '1 mois (30 jours)', value: 30 },
  { label: '2 mois (60 jours)', value: 60 },
];

confirmAndDeleteFile(filePath: string, index: number): void {
  console.log('🗑️ Demande de suppression du fichier :', filePath);
  console.log('📌 Index dans la liste :', index);

  const productId = this.editForm.get('id')?.value;

  if (!productId) {
    console.error('❌ Produit non défini ou ID manquant dans le formulaire.');
    alert("Produit introuvable, impossible de supprimer le fichier.");
    return;
  }

  this.produitStockService.deleteFile(productId, filePath).subscribe({
    next: () => {
      console.log('✅ Fichier supprimé côté serveur avec succès.');

      const currentList = this.editForm.get('documentPath')?.value || [];
      console.log('📂 Liste actuelle des fichiers (avant suppression) :', currentList);

      const updatedList = currentList.filter((_: any, i: number) => i !== index);
      console.log('📄 Nouvelle liste des fichiers (après suppression) :', updatedList);

      this.editForm.get('documentPath')?.setValue(updatedList);

      // **Ne pas fermer le modal ni faire autre chose ici**
      console.log('📝 Formulaire mis à jour avec la nouvelle liste des fichiers.');
    },
    error: (err) => {
      console.error('❌ Erreur lors de la suppression du fichier :', err);
      alert("Erreur lors de la suppression du fichier.");
    }
  });
}


updateProduct(): void {
  const form = this.editForm;

  if (form.invalid) {
    Object.keys(form.controls).forEach(field => {
      const control = form.get(field);
      if (control?.invalid) {
        console.error(`❌ Champ invalide: ${field}`, control.errors);
      }
    });
    form.markAllAsTouched();
    this.dialogService?.openInvalidFormDialog();
    return;
  }

  // Fonction utilitaire pour formater la date au format yyyy-MM-dd
  const formatDateToISO = (date: any): string | null => {
    if (!date) return null;
    const d = new Date(date);
    const month = '' + (d.getMonth() + 1);
    const day = '' + d.getDate();
    const year = d.getFullYear();
    return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
  };

  // Copie des valeurs du formulaire
  const dto = { ...form.value };

  // Conversion des dates en string ISO (yyyy-MM-dd)
  dto.datePeremption = formatDateToISO(dto.datePeremption);
  dto.dateFabrication = formatDateToISO(dto.dateFabrication);
  dto.dateOuverture = formatDateToISO(dto.dateOuverture);

  const formData = new FormData();
  // Ajout du DTO JSON dans un Blob
  formData.append('dto', new Blob([JSON.stringify(dto)], { type: 'application/json' }));

  // Ajout des fichiers uploadés (si existants)
  if (this.selectedFiles?.length) {
    this.selectedFiles.forEach(file => {
      formData.append('files', file);
    });
    console.log("📁 Fichiers ajoutés :", this.selectedFiles.map(f => f.name));
  } else {
    console.log("ℹ️ Aucun fichier sélectionné");
  }

  const productId = form.get('id')?.value;
  if (!productId) {
    console.error("❌ ID du produit introuvable dans le formulaire");
    return;
  }

  console.log("🚀 Envoi FormData :", { id: productId, dto, fichiers: this.selectedFiles });

  this.produitStockService.updateProduit(productId, formData).subscribe({
    next: (response) => {
      console.log("✅ Produit mis à jour :", response);
      this.updateTableRow?.(response);
      this.fetchProductList();
      this.modalService?.dismissAll();
      this.dialogService?.openSuccessDialog("Produit modifié avec succès.");
    },
    error: (err) => {
      console.error("❌ Erreur API :", err);
      this.handleErrorsService?.catchError(err);
    },
    complete: () => {
      console.log("✅ Requête terminée");
      this.initializePaginatorAndSort?.();
    }
  });
}

removeDocument(index: number): void {
  const docs: string[] = this.editForm.get('documentPath')?.value ?? [];
  docs.splice(index, 1);
  this.editForm.get('documentPath')?.setValue(docs);
  this.editForm.get('documentPath')?.markAsDirty();
}


extractFileName(docPath: string): string {
  return docPath.substring(docPath.lastIndexOf('/') + 1);
}


    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex(item => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
            this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
        }
    }

    confirmDelete(element: any) {
        this.dialogService.confirm('Etes-vous sûr de vouloir supprimer ce produit?')
            .then((result: any) => {
                if (result) {
                    this.deleteProduct(element.id);
                }
            });
    }
    deleteProduct(id: number) {
        this.produitStockService.deleteProuct(id).subscribe({
            next: response => {
                this.removeTableRow(id);
                this.dialogService.openSuccessDialog('Produit supprimé avec succès')
            
            },
            error : err => this.handleErrorsService.catchError(err),
            complete: () => this.initializePaginatorAndSort()
        });
    }

    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchValue = (event.target as HTMLInputElement).value.trim().toLowerCase()
        this.dataSource.filter = this.searchValue
    }

    openViewModel(element: ProduitStockDTO) {
        this.prd = element
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});

    }
    openModal(content: any) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'}).result.then(
            () => {
                this.form.reset()
            },
            () => {
                this.form.reset()
            }
        );
    }
    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {
        return [...this.displayedColumns, 'action']
    };
    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`produit_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }
    private getColsCookie() {
        const productCols = this.cookieService.get(`produit_${this.user_name}`); // Get the cookie value

        if (productCols) {
            this.displayedColumns = JSON.parse(productCols); // Convert the JSON string back to an object
            console.log('Retrieved object:', productCols);
        }
    }
}

